import { render, staticRenderFns } from "./ItineraryFormDataTable.vue?vue&type=template&id=46a51ee9&"
import script from "./ItineraryFormDataTable.vue?vue&type=script&lang=js&"
export * from "./ItineraryFormDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports